import type { AnalyticsTranslation } from "./en.analytics";

const analyticsRu: AnalyticsTranslation = {
  analytics: {
    nav: "Аналитика",
    title: "Аналитика",
    orgTitle: "Аналитика — все проекты",
    orgIntro: "Тестирование и баги в проде по всем проектам, которые вам доступны.",
    projectIntro: "Как идёт тестирование и что уходит в прод — по этому проекту.",
    loading: "Загрузка аналитики…",
    refreshing: "Обновление…",
    period: {
      label: "Период",
      p30d: "30 дней",
      p90d: "90 дней",
      p6m: "6 месяцев",
      p12m: "12 месяцев",
      custom: "Свой",
      from: "С",
      to: "По",
      apply: "Применить",
      range: "{{from}} – {{to}}",
      invalid: "Дата начала должна быть раньше даты окончания.",
    },
    export: {
      bugs: "Экспорт багов в CSV",
      tasks: "Экспорт задач в CSV",
    },
    units: { d: "д", h: "ч", m: "м" },
    insights: {
      title: "Выводы",
      none: "За этот период пока ничего не выделяется. Выводы появятся, когда будут завершённые раунды и разобранные баги.",
      good: "Хорошо",
      warning: "Стоит посмотреть",
      bad: "Требует внимания",
      fpyUp: "Доля задач, прошедших с первого раза, выросла до {{value}} (было {{previous}} в прошлом периоде).",
      fpyDown: "Доля задач, прошедших с первого раза, упала до {{value}} (было {{previous}} в прошлом периоде).",
      fpySame: "Доля задач, прошедших с первого раза, стабильна: {{value}}.",
      fpyOnly: "Доля задач, прошедших с первого раза: {{value}}.",
      testingGap: "{{value}} разобранных багов ({{n}}) должно было поймать тестирование.",
      testingGapWhere: "{{value}} разобранных багов ({{n}}) должно было поймать тестирование — больше всего в «{{label}}».",
      topRootCause: "Главная причина: {{label}} ({{value}} багов с указанной причиной).",
      slowMitigationBad: "Баги {{label}} устранялись в срок лишь в {{value}} случаев.",
      slowMitigationGood: "Баги {{label}} устранялись в срок в {{value}} случаев.",
      overdueActions: "Просроченных действий: {{n}}.",
      recurring: "Баги, вернувшиеся после закрытия: {{n}} (доля повторов {{value}}).",
      hotspot: "Больше всего провалов в кейсах с тегом «{{label}}» ({{n}}).",
    },
    testing: {
      title: "Тестирование",
      tasksTested: "Протестировано задач",
      roundsFinished: "Завершено раундов: {{n}}",
      firstPassYield: "С первого раза",
      fpyHint: "Раунд 1 без провалов · первых раундов: {{n}}",
      avgRounds: "Раундов до успеха",
      avgRoundsHint: "В среднем · 3 и больше: {{n}}",
      medianToPass: "Время до успеха",
      medianHint: "Медиана, готово к тесту → пройдено",
      findings: "Находки",
      findingsHint: "Проблемы, найденные вне написанных кейсов",
      monthly: "Раунды и провалы по месяцам",
      rounds: "Раунды",
      failures: "Проваленные результаты",
      fpyMonthly: "Доля прошедших с первого раза по месяцам",
      byTag: "Провалы по тегам",
      bySection: "Провалы по разделам",
      noFailures: "За этот период провалов нет.",
      slowest: "Дольше всех до успеха",
      slowestEmpty: "За этот период ни одна задача не прошла.",
      task: "Задача",
      time: "Время",
      roundsCol: "Раунды",
      testers: "Тестировщики",
      tester: "Тестировщик",
      results: "Результаты",
      problems: "Найдено проблем",
      testersEmpty: "За этот период результатов нет.",
      empty: "За этот период тестирования не было",
      emptyBody: "Когда тестировщики завершат раунды, здесь появятся доля прошедших с первого раза, число раундов, проблемные места и самые долгие задачи.",
    },
    bugs: {
      title: "Баги в проде",
      total: "Сообщено багов",
      openNow: "Открыто сейчас",
      recurrence: "Доля повторов",
      recurrenceHint: "Вернувшихся багов: {{n}}",
      actions: "Действия",
      actionsValue: "{{open}} открыто · {{overdue}} просрочено",
      onTime: "Выполнено в срок",
      onTimeHint: "Выполнено за период: {{n}}",
      monthly: "Баги по месяцам и критичности",
      bySeverity: "По критичности",
      rootCauses: "Причины",
      escapePoints: "Где их должны были поймать",
      escapeHint: "Выделены два этапа тестирования.",
      gap: "Пробел в тестировании",
      gapIntro: "Баги, которые должно было поймать тестирование.",
      gapShare: "багов с указанным этапом",
      gapMissing: "Ни один кейс это не покрывал",
      gapMissed: "Кейс был, но тестирование пропустило",
      gapByComponent: "По компонентам",
      gapNone: "За этот период ни один баг не связан с тестированием.",
      timings: "Время реакции по критичности",
      severity: "Критичность",
      count: "Багов",
      ack: "Принятие",
      mitigate: "Устранение",
      fix: "Исправление",
      target: "Цель",
      withinTarget: "В срок",
      noTarget: "Без цели",
      seenByVersion: "Баги по версиям",
      seenByVersionHint: "Каждый баг считается один раз на версию, по дате, когда его заметили в этом периоде.",
      firstSeenByVersion: "Где баги появились впервые",
      firstSeenByVersionHint: "Версия, в которой баг впервые заметили в приложении, если это было в этом периоде.",
      byComponent: "По компонентам",
      none: "За этот период нет.",
      unknown: "Не указано",
      empty: "За этот период багов в проде нет",
      emptyBody: "Когда появятся баги, здесь будут видны их критичность и месяцы, причины, этап, где их упустили, и скорость реакции.",
    },
    projects: {
      title: "Проекты",
      project: "Проект",
      tasksTested: "Протестировано задач",
      fpy: "С первого раза",
      bugs: "Баги",
      open: "Открыто",
      major: "S1 + S2",
      gap: "Пробел в тестировании",
      overdue: "Просроченные действия",
      sortBy: "Сортировать по: {{column}}",
      empty: "Вы пока не участник ни одного проекта.",
    },
  },
};

export default analyticsRu;
